<template>
  <v-app id="app">
    <navigation-drawer></navigation-drawer>
    <app-bar></app-bar>
    <slot></slot>
    <profile-menu></profile-menu>
    <profile-button></profile-button>
    <contact-box></contact-box>
    <loading />
    <product-version-badge></product-version-badge>
  </v-app>
</template>

<script>
import NavigationDrawer from '@/components/admin/navigation/navigation-drawer.vue';
import ProfileMenu from '@/components/admin/navigation/profile-menu.vue';
import ProfileButton from '@/components/admin/navigation/profile-button.vue';
import AppBar from '@/components/admin/navigation/app-bar';
import ContactBox from '@/components/admin/navigation/contact-box';
import Loading from '@/components/public/loading'
import ProductVersionBadge from '@/components/admin/product-version-badge.vue';

export default {
  name: 'Admin',
  components: {
    NavigationDrawer,
    ProfileMenu,
    ProfileButton,
    AppBar,
    ContactBox,
    Loading,
    ProductVersionBadge,
  },
  created() {
    if (window.FB) {
      window.FB.CustomerChat.hide();
    }
  }
}
</script>

<style lang="scss">
  * {
    font-family: "Noto Sans Thai", "Noto Sans", sans-serif;
  }
</style>
